import { CardStateService, EnumDto } from '@/api';

export default {
  getCardStateList: async (): Promise<EnumDto[]> => {
    const response = await CardStateService.cardStateControllerGetAll();
    return response.data;
  },
};
